import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { putExtensiveAttributeValues } from 'api/extensive-attribute-value.service';
import { ExtensiveAttributeValueBulkUpdateRequest } from 'types/entity';

export const EXTENSIVE_ATTRIBUTE_VALUE_UPDATE_STORE_NAME = 'extensiveAttributeValueUpdate';

export const updateExtensiveAttributeValues = createAsyncThunk(
  `${EXTENSIVE_ATTRIBUTE_VALUE_UPDATE_STORE_NAME}/update`,
  (payload: { projectId: string, extensiveAttributeDefinitionId: string, attributes: ExtensiveAttributeValueBulkUpdateRequest}, thunkAPI) => {
    const { projectId, extensiveAttributeDefinitionId, attributes } = payload;
    return putExtensiveAttributeValues(projectId, extensiveAttributeDefinitionId, attributes);
  },
);

export interface ExtendiveAttributeValueUpdateState {
  processing: boolean
  succeeded: boolean
  error: any
}

export const initialExtensiveAttributeValueUpdateState: ExtendiveAttributeValueUpdateState = {
  processing: false,
  succeeded: false,
  error: null,
};

export const extensiveAttributeValueUpdateSlice = createSlice({
  name: EXTENSIVE_ATTRIBUTE_VALUE_UPDATE_STORE_NAME,
  initialState: initialExtensiveAttributeValueUpdateState,
  reducers: {
    clear: (state) => {
      state.error = initialExtensiveAttributeValueUpdateState.error;
      state.processing = initialExtensiveAttributeValueUpdateState.processing;
      state.succeeded = initialExtensiveAttributeValueUpdateState.succeeded;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(updateExtensiveAttributeValues.pending, (state) => {
      state.processing = true;
    });
    builder.addCase(updateExtensiveAttributeValues.fulfilled, (state) => {
      state.processing = false;
      state.succeeded = true;
    });
    builder.addCase(updateExtensiveAttributeValues.rejected, (state, action) => {
      state.error = action.payload;
      state.processing = false;
    });
  },
});

export const extensiveAttributeValueUpdateActions = {
  ...extensiveAttributeValueUpdateSlice.actions,
  updateExtensiveAttributeValues,
};

export default extensiveAttributeValueUpdateSlice.reducer;
